var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96914 4.89961C7.29462 4.89961 8.36914 3.82509 8.36914 2.49961C8.36914 1.17413 7.29462 0.0996094 5.96914 0.0996094C4.64366 0.0996094 3.56914 1.17413 3.56914 2.49961C3.56914 3.82509 4.64366 4.89961 5.96914 4.89961Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.741277 10.0944C0.58537 10.5009 0.72462 10.9564 1.0685 11.2233C2.42239 12.274 4.12275 12.8996 5.96923 12.8996C7.81759 12.8996 9.51955 12.2728 10.8741 11.2201C11.2178 10.953 11.3568 10.4973 11.2006 10.091C10.3932 7.99044 8.35649 6.49961 5.97159 6.49961C3.58539 6.49961 1.54777 7.99207 0.741277 10.0944Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSetting);
export default __webpack_public_path__ + "static/media/account-setting.a702f2af05be20750bb1ad725e56248c.svg";
export { ForwardRef as ReactComponent };